import { NGXLogger } from 'ngx-logger';
import { FuseConfigService } from './../../../@fuse/services/config/config.service';
import { Injectable } from '@angular/core';
import { UserSettingsService } from '@feature/user-settings';
import { Subscription, tap } from 'rxjs';
import { Theme } from '../config/app.config';
import * as brand from '../../../../brand-themes';

/** 
 * Changes the current theme based on the users brand 
 * @see ResponsiveAppLayoutComponent as well
 */
@Injectable({
  providedIn: 'root'
})
export class ResponsiveBrandManagementService {

    private subscription : Subscription = null;

    constructor(private readonly logger: NGXLogger,
                private readonly userSettingsService: UserSettingsService,
                private readonly configService: FuseConfigService) { }

    /**
     * Initialises the brand management service so that changes made in the user settings service
     * are pushed to the Fuse configuration service.  This should immediately update the theme
     * which is used, as the user changes their configuration settings.
     * 
     * This function only needs to be executed once in the app.  Executing it more than once will
     * have no effect (for subsequent usages after the first).
     * 
     * @returns `true` if the service was initialised; `false` if it was already initialised, and so this
     * function had no effect.
     */
    initialiseBrandManagementService() : boolean {
        if(this.subscription) return false;

        this.subscription = this.userSettingsService.getUserSettings()
            .pipe(tap(us => {
                const theme: Theme = 'theme-' +  brand.platformBrandMap[us.BrandName];
                this.logger.info(`setting theme to "${theme} from usersettings".`)
                this.configService.config = { theme };
            }))
            .subscribe();
        return true;
    }
}
